import { render, staticRenderFns } from "./CardDesign.vue?vue&type=template&id=86e883c8"
import script from "./CardDesign.vue?vue&type=script&lang=js"
export * from "./CardDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports